var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports"},[_c('reports-list'),(_vm.activeItem)?_c('reports-modal',{attrs:{"item":_vm.activeItem}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }